import { Route, Switch } from 'react-router';
import { OrderListView } from './OrderListView';
import { Routes } from '@/utils/routes';
import { OrderDetails } from './OrderDetails';
import { useBreadcrumbs } from '@/components/Breadcrumbs/useBreadcrumbs';
import i18n from '@/utils/i18n';

export function OrdersPage() {
  useBreadcrumbs({
    id: 'ops-orders',
    priority: 100,
    items: [
      {
        label: i18n.t('Navigation:opsOrders'),
        href: Routes.orders(),
      },
    ],
  });
  return (
    <div className="tw:p-2 tw:pt-0 tw:pb-4 tw:max-w-[1400px]">
      <Switch>
        <Route path={Routes.orders()} exact component={OrderListView} />
        <Route
          path={Routes.orderDetails(':orderId')}
          component={OrderDetails}
        />
      </Switch>
    </div>
  );
}
